import { createContext } from 'react';

export type TTypeOfModalWindow = null | 'cropper';
export type TTypeOfErrorModalWindow = null | 'fileSizeExceeded' | 'fileUploadError' | 'invalidFileFormat';
export type TImageOrientation = 'horizontal' | 'vertical';
export interface ILoadFromFilePathOptions {
	filePath: string | null;
	preSignedUrl: string | null;
	entityID: string;
}

export interface IFormImageUploaderState {
	imageOrientation: TImageOrientation;
	isLoading: boolean;
	fullSizeSrc: string | null;
	croppedSizeSrc: string | null;
	typeOfModalWindow: TTypeOfModalWindow;
	typeOfErrorModalWindow: TTypeOfErrorModalWindow;
	loadingImageError: boolean;
}

export const formImageUploaderInitialState: IFormImageUploaderState = {
	imageOrientation: 'horizontal',
	isLoading: false,
	fullSizeSrc: null,
	croppedSizeSrc: null,
	typeOfModalWindow: null,
	typeOfErrorModalWindow: null,
	loadingImageError: false,
};

export interface IFormImageUploaderContext extends IFormImageUploaderState {
	setImageOrientation(value: TImageOrientation): void;
	setLoading(value: boolean): void;
	setFullSizeSrc(src: string | null): void;
	setCroppedSizeSrc(src: string | null): void;
	uploadImage(value: Blob): Promise<void>;
	changeTypeOfModalWindow(value: TTypeOfModalWindow): void;
	changeTypeOfErrorModalWindow(value: TTypeOfErrorModalWindow): void;
	setLoadingImageError(value: boolean): void;
}

export const FormImageUploaderContext = createContext<IFormImageUploaderContext>({
	setImageOrientation: () => undefined,
	setLoading: () => undefined,
	setFullSizeSrc: () => undefined,
	setCroppedSizeSrc: () => undefined,
	uploadImage: async () => undefined,
	changeTypeOfModalWindow: () => undefined,
	changeTypeOfErrorModalWindow: () => undefined,
	setLoadingImageError: () => undefined,
	...formImageUploaderInitialState,
});
